var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch/node_modules/isarray/index.js
// module id = 599
// module chunks = 0 1 2 3 4 5 6 7 8